import React, { Component } from "react";
import axios from 'axios';
import api from '../common/api';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from "@material-ui/core/styles";
import { Container, Row, Col } from "shards-react";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ConfirmDialog from '../common/ConfirmDialog'
import LinearProgress from '@material-ui/core/LinearProgress';
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import CustomToolbarSelect from "./CustomToolbarSelect";
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from "@material-ui/core/Tooltip";
import PublishIcon from '@material-ui/icons/Publish';
import DriveEtaIcon from '@material-ui/icons/DriveEta';	

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
	appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: '2rem',
    flex: 1,
    color: 'white'
  },
  paper: {
    padding: '2rem',
    textAlign: 'center',
  },
  checkedIcon:{
	  width: 16,
      height: 16,
  },
  option:{
  	  fontWeight: 600,
      fontSize:'0.75rem',
  },
  typography:{
	  fontSize: '0.75rem'
  },
  select:{
  	marginTop: '0',
  	marginRight:'12px',
  	padding: '0'
  },
  menu:{
  	fontSize: '0.75rem'
  }
});


class MaintenancePlanVersion extends React.Component {
    constructor(props) {
      	super(props);
		this.state = {
						snackbar:{open:false},
						maintenance_plan:{versions:[]},
						models:[],
						vehicles:[],
						models_filter_options:[],
						versions_filter_options:[],
						brand_filter:'',
						model_filter:'',
					 	loading: true,
					 	disabled: false,
					    dialog: {open: false, message: '', title:'', errors:{errors:{'errors':[]}}},
					    delete_dialog: {open: false, message: '', title:'', errors:{errors:{'errors':[]}}},
					 }
  	}

    async componentDidMount() {
		var params = this.getParams();
		var maintenance_plan = await this.getMaintenancePlan(params.id)
		var models = await this.getModels();
		var disabled = (params.view === '1') ? true : false
    	this.setState({loading: false, disabled: disabled})
    }

	getParams(){
		return this.props.match.params
	}

    getMaintenancePlan = (id) => {
		const token = localStorage.getItem('userToken')
		return axios
	     .get(api.maintenance_plans().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({maintenance_plan: res.data})
	      })
	      .catch(err =>{console.log(err)
	      })
    
    }

    getModels = (id) => {
		const token = localStorage.getItem('userToken')
		this.setState({loading: true})
		return axios
	     .get(api.versions().index(),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({models: res.data, vehicles:[], loading: false})
	      })
	      .catch(err =>{console.log(err)
	      })
    }



    handleSnackbar = () => {
    	var snackbar = this.state.snackbar
    	snackbar.open = !snackbar.open
    	this.setState({snackbar: snackbar})
    }

	getMuiTheme = () =>
		createMuiTheme({
		  overrides: {
		    MuiTableCell: {
		     root: {
		       padding: '0px 8px 0px 8px',
		       fontSize: '0.73rem'
		      }
		    }
		  }
	});


	getVehicles = () => {
		this.setState({loading: true})
		const token = localStorage.getItem('userToken')
		return axios
	     .get(api.vehicles().index(),{ headers: {"Authorization" : `Bearer ${token}`} })
	      .then(res => {
	      		this.setState({vehicles: res.data, models: [], loading: false})
	      })
	      .catch(err =>{console.log(err)
	      })
	}

	refreshModelsByBrand = (brand) =>{
		var models_filter_options = []
		//models_filter_options = this.state.models.filter(model => model.variation.brand.name === brand)
		if (brand !== '' && brand !== undefined){
			this.state.models.map((val,idx)=>{
				if (val.variation.brand.name === brand){
					if (!models_filter_options.includes(val.variation.dnrpa_description)){
						models_filter_options.push(val.variation.dnrpa_description)
					}
				}
			})
			this.state.vehicles.map((val,idx)=>{
				if (val.version.variation.brand.name === brand){
					if (!models_filter_options.includes(val.version.variation.dnrpa_description)){
						models_filter_options.push(val.version.variation.dnrpa_description)
					}
				}
			})
		} else {
			brand = ''
		}
		this.setState({models_filter_options: models_filter_options, brand_filter: brand})
	}  

	refreshVersionsByModel = (model_name) =>{
		var versions_filter_options	= []
		if (model_name !== '' && model_name !== undefined){
			var models = this.state.models.filter(model => model.variation.dnrpa_description	=== model_name)
			models.map((val,idx)=>{
				versions_filter_options.push(val.name)
			})

			var models = this.state.vehicles.filter(vehicle => vehicle.version.variation.dnrpa_description	=== model_name)
			models.map((val,idx)=>{
				if (versions_filter_options.indexOf(val.version.name) <= -1) {
					versions_filter_options.push(val.version.name)
				}				
			})
		} else {
			model_name = ''
		}
		this.setState({versions_filter_options: versions_filter_options, model_filter: model_name})
	}  

	render() {
		const classes = this.props.classes;
		const maintenance_plan = this.state.maintenance_plan
		const disabled = this.state.disabled
		const models_columns = (this.state.models.length > 0) ? true : false
		const vehicles_columns = (this.state.vehicles.length > 0) ? true : false
		var columns = [
			{
				name: "id",
				label: "Id",
				options: {
					filter: false,
					sort: true,
  					display: models_columns
				}
			},
			{
				name: "variation.brand.name",
				label: "Marca",
				options: {
					display: models_columns,
					filter: models_columns,
					filterList: (models_columns && this.state.brand_filter !== '') ? [this.state.brand_filter] : [],
					filterType: "select",
					sort: true,
					display: models_columns
				}
			},
			{
				name: "variation.dnrpa_description",
				label: "Modelo",
				options: {
					filter: (models_columns && this.state.models_filter_options.length > 0 ) ? true : false,
					filterList: (models_columns && this.state.model_filter !== '') ? [this.state.model_filter] : [],
					filterOptions: {
						names: this.state.models_filter_options
				    },
  					sort: true,
  					display: models_columns
				}
			},
			{
				name: "name",
				label: "Version",
				options: {
					filter: (models_columns && this.state.versions_filter_options.length > 0 ) ? true : false,
					filterType: 'multiselect',
					filterOptions: {
						names: this.state.versions_filter_options
				    },
					sort: true,
  					display: models_columns
				}
			},
			{
				name: "version.variation.brand.name",
				label: "Marca",
				options: {
					display: vehicles_columns,
					filter: vehicles_columns,
					filterList: (vehicles_columns && this.state.brand_filter !== '') ? [this.state.brand_filter] : [],
					filterType: "select",
					sort: true,
					display: vehicles_columns
				}
			},
			{
				name: "version.variation.dnrpa_description",
				label: "Modelo",
				options: {
					display: vehicles_columns,
					filter: (vehicles_columns && this.state.models_filter_options.length > 0 ) ? true : false,
					filterList: (vehicles_columns && this.state.model_filter !== '') ? [this.state.model_filter] : [],
					filterOptions: {
						names: this.state.models_filter_options
				    },
  					sort: true,
  					display: vehicles_columns
				}
			},
			{
				name: "version.name",
				label: "Version",
				options: {
					display: vehicles_columns,
					filter: (vehicles_columns && this.state.versions_filter_options.length > 0 ) ? true : false,
					filterType: 'multiselect',
					filterOptions: {
						names: this.state.versions_filter_options
				    },
					sort: true,
					display: vehicles_columns
				}
			},
			{
				name: "version.id",
				label: "ID Version",
				options: {
					filter: false,
					sort: true,
					display: vehicles_columns
				}
			},
			{
				name: "contract.name",
				label: "Contrato",
				options: {
					filter: vehicles_columns,
					sort: true,
					display: vehicles_columns
				}
			},
			{
				name: "plate",
				label: "Patente",
				options: {
					filter: vehicles_columns,
					filterType: 'textField',
					sort: true,
					display: vehicles_columns
				}
			},
			{

				name: (models_columns) ? "maintenance_plans" : "maintenance_plan_id", 
				label: "Asignado a este plan",
				options: {
					filter: true,
					sort: true,
			        filterOptions: {
			                    names: ['Asignado a este plan', 'Asignado a otro plan'],
			                    logic(maintenance_plans, filterVal) {
	    							var has_maintenance_plan = filterVal[0] === 'Asignado a otro plan'
								  	if (models_columns){
								  		if (maintenance_plans.length > 0){
								    		has_maintenance_plan = (maintenance_plans.filter(plan => plan.id === maintenance_plan.id).length > 0 ) ? true : false
								    		has_maintenance_plan = has_maintenance_plan && filterVal[0] === 'Asignado a este plan'
								  		}
								  	} else {
								  		if (maintenance_plans){
								    		has_maintenance_plan = (maintenance_plan.id === maintenance_plans) ? true : false
								    		has_maintenance_plan = has_maintenance_plan && filterVal[0] === 'Asignado a este plan'
								  		}
								  	}

								  	return !has_maintenance_plan 

			                    },
			                  },

					customBodyRender: (value, tableMeta, updateValue) => {
						var has_maintenance_plan = false
					  	if (models_columns){
						  	var version_id = tableMeta.rowData[0]
				    		has_maintenance_plan = (this.state.maintenance_plan.versions.filter(version => version.version.id === version_id).length > 0 ) ? true : false
					  	} else {
				    		has_maintenance_plan = (this.state.maintenance_plan.id === value) ? true : false
					  	}


						return (
							<Chip
							 label={(has_maintenance_plan) ? "Si" : "No"} 
							 color={(has_maintenance_plan) ? "primary" : "secondary"}
							/>
						);         
					}
				}
			}				
		];
		const options = {
			download: false,
			print:false,
			responsive: 'stacked',
			selectableRowsOnClick: true,
			rowsPerPage: 10,
			selectableRows: true,
			onFilterChange: (changedColumn, filterList) => {
				if (changedColumn === 'variation.brand.name') {
					this.refreshModelsByBrand(filterList[1][0])
				}
				if (changedColumn === 'version.variation.brand.name'){
					this.refreshModelsByBrand(filterList[4][0])
				}
				if (changedColumn === 'variation.dnrpa_description'){
					this.refreshVersionsByModel(filterList[2][0])
				}
				if (changedColumn === 'version.variation.dnrpa_description'){
					this.refreshVersionsByModel(filterList[5][0])
				}
			},			
		    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
		      <CustomToolbarSelect selectedRows={selectedRows} displayData={displayData} setSelectedRows={setSelectedRows} maintenance_plan_id={this.state.maintenance_plan.id} models={this.state.models} vehicles={this.state.vehicles} modelsAssignment={models_columns} vehiclesAssignment={vehicles_columns}/>
		    ),
			customToolbar: () => {
			  return (
			    <React.Fragment>
			      <Tooltip title={"Importar"}>
			        <IconButton onClick={(e)=>{window.location.href="/maintenance-plan-version-import/"+this.state.maintenance_plan.id}}>
			          <PublishIcon />
			        </IconButton>
			      </Tooltip>
			      <Tooltip title={(this.state.models.length === 0) ? "Asignar Modelos" : "Asignar Patentes"}>
			        <IconButton onClick={(e)=>{(this.state.models.length === 0) ? this.getModels() : this.getVehicles()}}>
			          <DriveEtaIcon />
			        </IconButton>
			      </Tooltip>
			  </React.Fragment>
			  );
			},
			textLabels: {
			      toolbar: {
			        search: "Buscar",
			        viewColumns: "Ver columnas",
			        filterTable: "Filtros",   
			      },
			      body: {
			          noMatch: (this.state.loading === false) ?
			              'No hay resultados' :
			              <CircularProgress />,
			      },
			      selectedRows: {
			        text: "fila(s) seleccionadas"
			      },
			      viewColumns: {
			        title: "Ver columnas",
			      },
			      pagination: {
			        next: "Siguiente",
			        previous: "Anteior",
			        rowsPerPage: "Cantidad por página:",
			        displayRows: "de",      
			      },
			      filter: {
			        all: "Todos",
			        title: "Filtros",
			        reset: "Limpiar"
			      }
			  }
		};
		var data = (this.state.models.length > 0) ? this.state.models : this.state.vehicles 
		return (
			<React.Fragment>
				<Snackbar open={this.state.snackbar.open} autoHideDuration={10000} onClose={this.handleSnackbar}>
					<Alert onClose={this.handleSnackbar} severity={this.state.snackbar.severity}>
					  {this.state.snackbar.success_message}
					</Alert>
				</Snackbar>
				<ConfirmDialog 
				      confirm_dialog={this.state.delete_dialog.open} 
				      title={this.state.delete_dialog.title}
				      message={this.state.delete_dialog.message}
				      onClose={this.handleDialogClose} 
				      onAccept={this.handleDelete}
				      onCancel={this.handleDialogCancel}
				      errors={this.state.delete_dialog.errors}
				/>

				<ConfirmDialog 
				      confirm_dialog={this.state.dialog.open} 
				      title={this.state.dialog.title}
				      message={this.state.dialog.message}
				      onClose={this.handleDialogClose} 
				      onAccept={this.handleDialogAccept}
				      onCancel={this.handleDialogCancel}
				      errors={this.state.dialog.errors}
				/>
		        <Container fluid className="main-content-container px-4 position-relative">
		        <Row>
			        <Col>
						<Typography variant="h6">Plan de mantenimiento {this.state.maintenance_plan.name}</Typography>
			        </Col>
		        </Row>
				{(!this.state.loading)
					?	
						<Row>
							<Col className="p-2">
								<MuiThemeProvider theme={this.getMuiTheme()}>
									<MUIDataTable
										title={(this.state.models.length > 0) ? "Habilitar versiones" : "Habilitar patentes"}
										data={Object.values(data)}
										columns={columns}
										options={options}
									/>
									<div style={{textAlign: "right"}}>
										<Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/maintenance-plans"}>
										Volver
										</Button>
									 </div>
								</MuiThemeProvider>
							</Col>
						</Row>
					:
						<LinearProgress /> 					
				}
				</Container>
			</React.Fragment>
		)
	}

}

export default withStyles(useStyles)(MaintenancePlanVersion);

